export const isDerivedConversationLabel = (conversationLabelId: string) => {
  try {
    return parseInt(conversationLabelId, 10) < 0;
  } catch {
    return false;
  }
};
